// extracted by mini-css-extract-plugin
module.exports = {"errorContainer":"ErrorComponent_errorContainer__OJR4p","error":"ErrorComponent_error__HQGPa","header":"ErrorComponent_header___0f38","text":"ErrorComponent_text__qseZ9"};